import React from 'react';
import CalendarMonth from '@mui/icons-material/CalendarMonth';
import DateTimePicker from '@wojtekmaj/react-datetimerange-picker';
import '@wojtekmaj/react-datetimerange-picker/dist/DateTimeRangePicker.css';
import 'react-calendar/dist/Calendar.css';

export default function DatetimeRangePicker(props) {
  return (
    <>
      <style>{`
        .datetime-range-picker-wrapper {
          white-space: nowrap;
        }
        
        .datetime-range-picker-wrapper input[type=number]::-webkit-outer-spin-button,
        .datetime-range-picker-wrapper input[type=number]::-webkit-inner-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }
        
        .datetime-range-picker-wrapper select {
          -webkit-appearance: none;
        }
        
        .datetime-range-picker-wrapper .react-calendar__tile--now {
          background: #f2f2f2;
        }
        
        .datetime-range-picker-wrapper .react-datetimerange-picker__calendar--open {
          left: 50px !important;
          z-index: 5000;
          box-shadow: 0px -1px 10px 1px rgba(0,0,0,.2);
          border: none;
        }
        
        .datetime-range-picker-wrapper .react-datetimerange-picker__wrapper {
          height: 32px;
          border: 1px solid #c4c4c4;
          border-radius: 5px;
          margin: 0 10px 0 10px;
          display: flex;
          align-items: center;
        }
        
        .datetime-range-picker-wrapper .react-datetimerange-picker__wrapper:hover {
          border-color: #212121;
        }
        
        .datetime-range-picker-wrapper .react-datetimerange-picker__inputGroup {
          display: flex;
          align-items: center;
          height: 100%;
        }
        
        .datetime-range-picker-wrapper .react-datetimerange-picker__inputGroup__input {
          font-size: 13px !important;
          line-height: 1 !important;
          height: auto !important;
        }
        
        .datetime-range-picker-wrapper .react-datetimerange-picker__inputGroup__amPm {
          font-size: 13px !important;
          line-height: 1 !important;
          height: auto !important;
        }
        
        .datetime-range-picker-wrapper .react-datetime-picker__inputGroup__divider {
          font-size: 13px !important;
          line-height: 1 !important;
        }
        
        .datetime-range-picker-wrapper .react-datetimerange-picker__range-divider {
          margin: 0 10px;
          font-size: 13px !important;
          line-height: 1 !important;
        }
        
        .datetime-range-picker-wrapper .react-datetimerange-picker__calendar-button {
          padding: 1px 2px 2px 2px;
        }
        
        .datetime-range-picker-wrapper .react-calendar__tile--range {
          background: #006edc;
          color: #f2f2f2;
          font-weight: bold;
        }
        
        .datetime-range-picker-wrapper .react-calendar__tile--rangeStart {
          border-radius: 50px 0 0 50px;
        }
        
        .datetime-range-picker-wrapper .react-calendar__tile--rangeEnd {
          border-radius: 0 50px 50px 0;
        }
        
        .datetime-range-picker-wrapper .react-calendar__tile--rangeBothEnds {
          border-radius: 50px;
        }
        
        .datetime-range-picker-wrapper .react-calendar__tile--active {
          color: #fff;
          background: #3789dc;
        }
        
        .datetime-range-picker-wrapper .react-calendar__navigation,
        .datetime-range-picker-wrapper .react-calendar abbr {
          font-weight: 600;
        }
        
        /* Ensure all input elements have consistent font size */
        .datetime-range-picker-wrapper input,
        .datetime-range-picker-wrapper select,
        .datetime-range-picker-wrapper .react-datetimerange-picker__inputGroup * {
          font-size: 13px !important;
          line-height: 1 !important;
        }
        
        .datetime-range-picker-wrapper .react-datetimerange-picker__inputGroup select {
          font-size: 13px !important;
          line-height: 1 !important;
          height: auto !important;
        }
      `}</style>
      <div className="datetime-range-picker-wrapper">
        <DateTimePicker
          clearIcon={false}
          maxDate={new Date()}
          maxDetail="second"
          rangeDivider="to"
          disableClock
          calendarIcon={<CalendarMonth color="action" />}
          {...props}
        />
      </div>
    </>
  );
}